// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76e3a821","952":"fd0c5ae0"}[chunkId] + ".chunk.js";
};